import React, { useMemo } from "react";
import { CalendarDays, Crown, Medal, Trophy } from "lucide-react";
import { useAvatar } from "../../../context/AvatarContext";
import Avatar from "../../../components/ui/Avatar";
import PlayerProfilePreview from "./PlayerProfilePreview";
import RoomCard from "./RoomCard";

export default function RoomDailyTopPlayers({ players = [] }) {
  const { getPlayerAvatar } = useAvatar();
  const topPlayers = useMemo(
    () =>
      [...players]
        .filter((player) => player && Number.isFinite(Number(player.score)))
        .sort((left, right) => Number(right.score || 0) - Number(left.score || 0))
        .slice(0, 3),
    [players]
  );

  return (
    <RoomCard
      title="Top 3 joueurs du jour"
      
      action={
        <div className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-amber-700">
          <CalendarDays className="h-3.5 w-3.5" />
          Jour
        </div>
      }
      contentClassName="space-y-3"
    >
      {topPlayers.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-4 py-5 text-sm text-slate-500">
          Aucun score disponible pour le moment.
        </div>
      ) : (
        topPlayers.map((player, index) => {
          const Icon = index === 0 ? Crown : index === 1 ? Trophy : Medal;

          return (
          <div
            key={`${player.player_id || player.uid || player.pseudo}-${index}`}
            className={`flex items-center justify-between gap-3 rounded-2xl border px-3 py-2.5 transition hover:-translate-y-0.5 ${
              index === 0
                ? "border-amber-200 bg-[linear-gradient(145deg,#fef3c7,#ffffff)] shadow-[0_10px_30px_rgba(245,158,11,0.16)]"
                : "border-amber-100 bg-[linear-gradient(145deg,#fffbeb,#ffffff)]"
            }`}
          >
            <div className="flex min-w-0 items-center gap-3">
              <div
                className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-xl text-xs font-bold ${
                  index === 0
                    ? "bg-amber-400 text-slate-950 shadow-[0_0_0_5px_rgba(251,191,36,0.20)] animate-pulse"
                    : "bg-amber-100 text-amber-700"
                }`}
              >
                <Icon className="h-4 w-4" />
              </div>
              <Avatar
                src={
                  getPlayerAvatar(player)?.image ||
                  getPlayerAvatar(player)?.src ||
                  null
                }
                name={player.pseudo || "Joueur"}
                size="xs"
                rounded="full"
              />
              <PlayerProfilePreview
                player={player}
                avatar={getPlayerAvatar(player)}
                subtitle={`#${index + 1}`}
                subtitleClassName="text-slate-400"
                nameClassName="text-sm text-slate-900"
              />
            </div>

            <div className="flex-shrink-0 text-right">
              <div className="text-base font-semibold text-slate-950">
                {player.score ?? 0}
              </div>
              <div className="text-[10px] uppercase tracking-[0.14em] text-slate-400">
                pts
              </div>
            </div>
          </div>
          );
        })
      )}
    </RoomCard>
  );
}
